import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import VueResizeText from 'vue-resize-text'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './app.component.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { settings } from '@/settings/settings'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { CacheService } from './services/cache.service'
import vuescroll from 'vuescroll/dist/vuescroll-native'
import VueGtm from '@gtm-support/vue2-gtm';
import "core-js/stable/global-this"
import "core-js/stable/array";
import LottieAnimation from 'lottie-web-vue'

function computedData() {
  return {
    location_name: 'deviceModule.deviceConfig.location_name',
    player_name: 'deviceModule.deviceConfig.name',
    player_serial: 'deviceModule.deviceConfig.pid',
  }
}

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueAwesomeSwiper)
Vue.use(LottieAnimation)
Vue.use(VueResizeText)
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      detectResize: false,
    },
    bar: {
      disable: true
    },
    scrollPanel: {
      scrollingX: false,
    }
  }
})
Vue.use(VueGtm, {
  id: 'GTM-N4D8G3B', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  vueRouterAdditionalEventData: () => (
    {
      playerData: computedData()
    }
  ),
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$cacheService = new CacheService()

Vue.use(VueNativeSock, process.env.VUE_APP_WSS_EU_HOST, {  
  connectManually: true,
  reconnection: false, // (Boolean) whether to reconnect automatically (false)
  reconnectionDelay: 15 * 1000,
  format: 'json', store 
})